import './serp-empty.less';

export default angular.module('cian.newbuild.filter.serpEmpty', [])
  .directive('serpEmpty', () => ({
    restrict: 'E',
    template: require('./serp-empty.jade'),
    controller: [
      '$log',
      '$scope',
      '$window',
      'AnalyticsService',
      'SerpListService',
      'FilterService',
      'ApiService',
      'StateService',
      ($log, $scope, $window, AnalyticsService, SerpListService, FilterService, ApiService, StateService) => {
        const ctrl = {};

        $scope.$watchCollection(
          () => $window._empty_similar_links,
          newVal => ctrl.similarLinks = newVal
        );

        ctrl.email = StateService.email;

        const successSend = res => {
          $log.debug('success', res);
          ctrl.isSubscribed = true;
          AnalyticsService.trackCA('subscription', 'Send', 'From_Empty', true, {
            searchConditions: SerpListService.lastQuery,
            email: ctrl.email,
          });
        };

        const failSend = err => {
          $log.error(err);
          Notifications.add({
            type: 'error',
            content: 'При оформлении подписки возникла проблема. Попробуйте позже.',
            timeout: 5000
          });
        };

        ctrl.subscribe = () => {
          if (ctrl.subscribeForm.$invalid) {
            return;
          }

          ctrl.isLoading = true;

          const data = {
            email: ctrl.email,
            dealType: FilterService.dealType,
            title: SerpListService.getSearchTitle(),
            filterParams: SerpListService.getFullUrl(),
          };

          ApiService.saveSearch(data)
            .then(successSend)
            .catch(failSend)
            .finally(() => ctrl.isLoading = false);
        };

        ctrl.isEmailInvalid = () => ctrl.subscribeForm.$submitted && ctrl.subscribeForm.email.$invalid;

        return ctrl;
      }],
    controllerAs: 'serpEmpty',
  }))
  .name;



// WEBPACK FOOTER //
// ./src/serp/directives/serp-empty/serp-empty.dir.js